export default "__VITE_ASSET__DiGs8DFp__"